import React from "react"
import { Table } from "react-bootstrap"
import _ from "lodash"

import formatRate from "@/pricing/formatRate"

const FlatRatesheetView = ({ value, previousValues = false, currencyCode = undefined }) => {
  const currency = value.currencyCode || currencyCode
  const textStyle = previousValues ? "original-product-text" : ""

  return (
    <Table>
      <thead className="mb-2">
        <tr>
          <th className={textStyle}>Category</th>
          <th className={`text-right ${textStyle} `}>Rate</th>
        </tr>
      </thead>
      <tbody>
        {_.map(value.rates, (rate, ctg) => (
          <tr key={ctg}>
            <td className={textStyle}>{_.capitalize(ctg)}</td>
            <td className={`text-right ${textStyle} `}>{formatRate(rate, currency)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export default FlatRatesheetView
